const mediaEditorTypes = {
  SAVING_EDITED_MEDIA: 'SAVING_EDITED_MEDIA',
};

export default mediaEditorTypes;
